import { API } from '@/lib/api';

export const PRODUCT_TYPES = ['AVATAR','OUTFIT','PROFILE_FRAME','BADGE','TITLE','THEME','BUNDLE'];

export const TYPE_LABELS = {
  AVATAR:'صورة رمزية',OUTFIT:'زي',PROFILE_FRAME:'إطار ملف',BADGE:'وسام',TITLE:'لقب',THEME:'ثيم',BUNDLE:'حزمة',
  AVATAR_BASE:'رمز أساسي',AVATAR_CLOTHING:'ملابس رمز',AVATAR_ACCESSORY:'إكسسوار رمز',
  ICON_PACK:'حزمة أيقونات',BANK_CARD_SKIN:'تصميم بطاقة',DASHBOARD_PACK:'حزمة لوحة',
  SEASONAL_ITEM:'عنصر موسمي',OTHER_SUPPORTED_COSMETIC:'عنصر تجميلي'
};

export const PRICING_LABELS = {FREE:'مجاني',USD:'USD',LBP:'LBP',USD_OR_LBP:'USD أو LBP',XP:'XP',SUBSCRIPTION_INCLUDED:'مشمول بالاشتراك',ACHIEVEMENT_UNLOCK:'فتح بإنجاز',LEVEL_UNLOCK:'فتح بمستوى',MANAGER_GRANT:'منح إداري',GAMIFICATION_REWARD:'مكافأة تقدم'};
export const EQUIPPABLE_TYPES = new Set(PRODUCT_TYPES.filter(type=>type!=='BUNDLE'));

export function assetUrl(asset){
  const value=typeof asset==='string'?asset:(asset?.url||asset?.storage_path);
  if(!value)return null;
  if(/^https?:\/\//i.test(value))return value;
  if(value.startsWith('/api/'))return `${API.replace(/\/api$/,'')}${value}`;
  return `${API}/files/${value.replace(/^\/+/, '')}`;
}

export function formatPrice(product,currency){
  const pricing=product?.pricing||{},effective=product?.effective_prices||{};
  if(pricing.pricing_type==='FREE')return 'مجاني';
  if(pricing.pricing_type==='XP')return `${Number(effective.xp ?? pricing.price_xp ?? 0).toLocaleString('en-US')} XP`;
  if(pricing.pricing_type==='SUBSCRIPTION_INCLUDED')return 'مشمول بالاشتراك';
  if(pricing.pricing_type==='MANAGER_GRANT')return 'منح إداري فقط';
  if(pricing.pricing_type==='GAMIFICATION_REWARD')return 'مكافأة تقدم';
  if(pricing.pricing_type==='ACHIEVEMENT_UNLOCK')return 'يتطلب إنجازًا';
  if(pricing.pricing_type==='LEVEL_UNLOCK')return 'يتطلب مستوى';
  const selected=currency||(pricing.pricing_type==='LBP'?'LBP':'USD');
  const value=selected==='LBP'?Number(effective.lbp ?? pricing.price_lbp ?? 0):Number(effective.usd ?? pricing.price_usd ?? 0);
  return selected==='LBP'?`${value.toLocaleString('en-US')} ل.ل`:`$${value.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}`;
}

export const THEME_FIELDS = [
  ['background','الخلفية الأساسية'],['secondary_background','الخلفية الثانوية'],['surface','السطح'],['elevated_surface','السطح المرتفع'],
  ['primary_text','النص الأساسي'],['secondary_text','النص الثانوي'],['muted_text','النص الخافت'],['primary_action','الإجراء الأساسي'],
  ['primary_action_text','نص الإجراء'],['secondary_action','الإجراء الثانوي'],['border','الحدود'],['accent','اللون البارز'],
  ['navigation_background','خلفية التنقل'],['navigation_text','نص التنقل'],['navigation_active','التنقل النشط'],['card_background','خلفية البطاقة'],
  ['card_border','حد البطاقة'],['input_background','خلفية الحقل'],['input_border','حد الحقل'],['input_text','نص الحقل']
];

const rgb=value=>[1,3,5].map(i=>parseInt(value.slice(i,i+2),16));
const lum=value=>rgb(value).map(v=>{const x=v/255;return x<=.03928?x/12.92:Math.pow((x+.055)/1.055,2.4);}).reduce((sum,v,i)=>sum+v*[.2126,.7152,.0722][i],0);
export function contrastRatio(a,b){if(!/^#[0-9a-f]{6}$/i.test(a||'')||!/^#[0-9a-f]{6}$/i.test(b||''))return 0;const values=[lum(a),lum(b)].sort((x,y)=>y-x);return (values[0]+.05)/(values[1]+.05);}
export function themeWarnings(theme={}){return [['الخلفية',theme.background,theme.primary_text],['السطح',theme.surface,theme.primary_text],['الإجراء',theme.primary_action,theme.primary_action_text],['التنقل',theme.navigation_background,theme.navigation_text],['الإدخال',theme.input_background,theme.input_text]].map(([label,a,b])=>({label,ratio:contrastRatio(a,b)})).filter(item=>item.ratio<4.5);}

export function requestId(prefix='store'){return globalThis.crypto?.randomUUID?.()||`${prefix}_${Date.now()}_${Math.random().toString(36).slice(2)}`;}
